module.exports = __webpack_public_path__ + "static/media/dashboard_logo.7e71ca8e.png";